import { hexToHue } from 'annotation-tools/utils';
import { ILabelFromApi, ILabelFromApiType } from '../../../types/record/label';
import {
  ILabelAPIValidationErrorFactory,
  ILabelAPIValidationErrorType,
  LabelAPIRawSuccessResponseType,
  LabelAPIRawValidationErrorType
} from '../../types/label/api-response';
import { nullableToStringList } from '../nullable-to-string-list';

export const ILabelFromAPISuccessResponse = ({
  id,
  name,
  color,
  model_annotation_count,
  project_annotation_count,
  can_be_deleted
}: LabelAPIRawSuccessResponseType): ILabelFromApiType =>
  ILabelFromApi({
    id,
    name,
    hue: hexToHue(color),
    numUsedInModelAnnotation: model_annotation_count,
    numUsedInProjectAnnotation: project_annotation_count,
    canBeDeleted: can_be_deleted
  });

export const ILabelAPIValidationError = ({
  name,
  color
}: LabelAPIRawValidationErrorType): ILabelAPIValidationErrorType =>
  ILabelAPIValidationErrorFactory({
    name: nullableToStringList(name),
    hue: nullableToStringList(color)
  });
